import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import axios from 'axios';
import {
  CardStyle,
  MainTeamContainer,
  TitleContMain,
  TeamsDesc,
  ContainerB,
  GridContainer,
} from '../styles/TeamStyle';

import ScrollToTop from './ScrollToTop';

import { Title, TitleDash, TitleHeadComCont } from '../styles/CommonStyles';

const Team = (scrollToTop, classes, isVisible) => {
  const [teamData, setTeamData] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  useEffect(() => {
    axios
      .get('https://leapot-lms-backend-dev.onrender.com/api/getteamdata')
      .then((response) => {
        setTeamData(response.data.teams);
      })
      .catch((error) => {
        console.error('Error fetching team data:', error);
      });
  }, []);

  return (
    <MainTeamContainer>
      <TitleContMain>
        <TitleHeadComCont>
          <Title
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="300"
            data-aos-delay="150"
          >
            Our Team
          </Title>
          <TitleDash
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="500"
            data-aos-delay="200"
          />
        </TitleHeadComCont>
      </TitleContMain>

      <ContainerB>
        <TeamsDesc>
          Welcome to Leapot Team. Our team is always pushing the envelope in
          terms of innovation to provide you with state-of-the-art solutions
          that promote efficiency and growth.
        </TeamsDesc>
        <GridContainer>
          <Grid
            container
            spacing={isMobile ? 2 : 4}
            justifyContent="center"
            alignItems="center"
            sx={{
              padding: isMobile ? '0 1rem' : '0 2rem',
              marginTop: '10px',
            }}
          >
            {teamData.length > 0 &&
              teamData.map((item, index) => (
                <Grid
                  item
                  key={index}
                  xs={12}
                  sm={6}
                  md={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: isMobile ? '1rem' : '1.5rem',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      maxWidth: 400,
                      minHeight: isMobile ? 300 : 400,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-5px)',
                        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: isMobile ? '1rem' : '1.5rem',
                        height: '100%',
                      }}
                    >
                      <img
                        alt={item.name}
                        src={item.image}
                        style={{
                          width: isMobile ? '150px' : '210px',
                          height: isMobile ? '150px' : '210px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          border: '4px solid #036ACB',
                          marginBottom: '1.5rem',
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: '#036ACB',
                          fontSize: isMobile ? '1.1rem' : '1.25rem',
                          textAlign: 'center',
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: 'text.secondary',
                          textAlign: 'center',
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          marginTop: '0.5rem',
                        }}
                      >
                        {item.designation}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </GridContainer>
      </ContainerB>
      <ScrollToTop
        isVisible={isVisible}
        scrollToTop={scrollToTop}
        classes={classes}
      />
    </MainTeamContainer>
  );
};

export default Team;
